import axios from 'axios'

const QUOTE_AND_BUY_URL = `/api/quoteandbuy-service`

export const getVehicleByRegiNumber = (regiNumber: string) => axios.get(QUOTE_AND_BUY_URL + `/vehicles/${regiNumber}`)
